import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';
import { Observable } from 'rxjs';
import { getQueryStringFromObject, ListServerPaginationStateModel } from '../../../../../common';
import { ShipmentWaybillEndpoint } from '../../constants';
import {
  ShipmentWaybillGoodsItemListSearchCriteria,
  ShipmentWaybillGoodsItemModel,
} from '../../models/shipment-waybill-goods-items.model';

@Injectable({
  providedIn: 'root',
})
export class ShipmentWaybillGoodsItemsService {
  constructor(private http: WrapperHttpService) {}

  getShipmentWaybillGoodsItems(
    searchCriteria: ShipmentWaybillGoodsItemListSearchCriteria,
  ): Observable<ListServerPaginationStateModel<ShipmentWaybillGoodsItemModel>> {
    const url = `${API_URL}${ShipmentWaybillEndpoint.Base}${ShipmentWaybillEndpoint.Waybills}${
      ShipmentWaybillEndpoint.GoodsItems
    }?${getQueryStringFromObject({
      ...searchCriteria.waybillIdView,
      page: searchCriteria.page,
      size: searchCriteria.size,
    })}`;

    return this.http.withLoading().get<ListServerPaginationStateModel<ShipmentWaybillGoodsItemModel>>(url);
  }
}
